<template>
<div class="establishment-list">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>Programme National</small>
        <br>
        Liste des établissements
      </h1>
      <hr>
    </div>
  </div>
  <sui-table :columns="table.columns"
            :actions="table.actions"
            :keyfield="table.keyfield"
            :list="formattedlist"
            title="Liste des établissements"
            :filterGen="filters"
            :filter="filter"
            :filterVariables="filterVariables"
            @update="update($event)"/>
</div>
</template>

<script>
import { mapState } from 'vuex'

import suiTable from '@/sui/components/table'
import regions from '@/sui/tools/regions'

export default {
  name: 'establishment-list',

  created () {
    this.$store.dispatch('establishment/all')
  },

  data () {
    const cl = 'table-column-filter'
    const col = (e, f) => `${e} <span class='${cl}'>(${f})</span>`
    return {
      filter: '',
      filterVariables: [
        { key: 'id', field: 'id', name: `ID de l'établissement` },
        { key: 'n', field: 'name', name: `Nom` },
        { key: 'f', field: 'finess', name: `Numéro FINESS` },
        { key: 'a', field: 'address', name: 'Adresse' }
      ],
      filters: [
        {
          title: 'Filtres',
          list: [
            {
              name: '(Aucun)',
              filter: ''
            },
            {},
            ...regions.filters
          ]
        }
      ],
      table: {
        columns: [
          {
            html: col('Nom', '$n'),
            field: 'name'
          },
          {
            html: col('Finess', '$f'),
            field: 'finess'
          },
          {
            html: col('Adresse', '$a'),
            field: 'address'
          }
        ],

        actions: [
          {
            event: 'update',
            name: 'Mettre à jour'
          }
        ],

        keyfield: 'id'
      }
    }
  },

  computed: {
    ...mapState({
      all: state => state.establishment.all
    }),

    formattedlist () {
      const list = []
      this.all.forEach(
        e => {
          list.push(
            {
              name: e.n,
              finess: e.c,
              address: e.a,
              filterlabel: `${e.n} ${e.c} ${e.a}`
            }
          )
        }
      )
      return list
    }
  },

  methods: {

    update: function (e) {
      this.$store.dispatch('establishment/update', { f: e.finess })
    }
  },

  components: {
    'sui-table': suiTable
  }
}
</script>

<style lang="less" scoped>

</style>
